import { AuthService } from "./../../shared/models/auth.service";
import { TranslateService } from "./../../shared/translate/translate.service";
import { Component, OnInit, ViewChild } from "@angular/core";
import {
  ApplicationRouteURL,
  RoleLevel,
  IAPIResponse,
  PermissionType,
  IKeyValueInterface,
  WeGoConfig
} from "../../shared/config";
import {
  TermsConditionModel,
  AcceptanceMomentModel
} from "../models/terms-condition.model";
import { InstanceService } from "../../instance/models/instance.service";
import { Location } from "@angular/common";
import { TermsAndConditionsService } from "../models/terms-conditions.service";
import { Router, ActivatedRoute } from "@angular/router";
import { CompanyService } from "../../company/models/company.service";
import { OrganizationService } from "../../organization/models/organization.service";
import { SharedVehicleGroupService } from "../../sharedvehiclegroup/models/sharedvehiclegroup.service";
import { ContractTypeGroupService } from "../../contracttypegroup/models/contracttypegroup.service";
import { SubscriptionService } from "../../sharedvehiclegroupsubscription/models/sharedvehiclegroupsubscription.service";
const SlimSelect = require("slim-select");

@Component({
  selector: "Wego-Add-TermsAndCondition",
  template: require('../views/terms-condition-update.component.html'),
  providers: [
    InstanceService,
    TermsAndConditionsService,
    CompanyService,
    OrganizationService,
    SharedVehicleGroupService,
    ContractTypeGroupService,
    SubscriptionService
  ]
})
export class TermsAndConditionAddUpdateComponent implements OnInit {
  selectedContractTypeGroupList: string[];
  OldVersion: number;
  newVersion: number;
  SubscriptionList: any[];
  ctgSelect: any;
  contractTypeGroupList: any[];
  permissionType: any;
  SVGList: any[];
  OrganizationList: any[];
  CompanyList: any[];
  urlTermsAndConditionList: string;
  urlDefaultPage: string;
  roleLevel = RoleLevel;
  model: TermsConditionModel;
  apiResponse: IAPIResponse;
  isEditMode: boolean;
  instanceList: any;
  errorMessage: string;
  private popupMsg: string;
  private SuccessMsg: string;
  errorModel: IKeyValueInterface[];
  apiErrorMsg: string;
  sub: any;
  termsAndConditionHashId: string;
  pageName: string;
  private breadCrumbTitle: string;
  private breadCrumbList: string;
  private module: string;
  isLoading: boolean;
  typeList: any;

  @ViewChild("successPopup") public successPopup: any;
  @ViewChild("newVersionModal") public newVersionModal: any;
  @ViewChild("termsAndConditionForm") public termsAndConditionForm: any;

  constructor(
    private translate: TranslateService,
    public authService: AuthService,
    public instanceService: InstanceService,
    private locationService: Location,
    private termsAndConditionsService: TermsAndConditionsService,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private companyService: CompanyService,
    private organizationService: OrganizationService,
    private sharedVehicleGroupService: SharedVehicleGroupService,
    private contractTypegroupService: ContractTypeGroupService,
    private subscriptionService: SubscriptionService
  ) {}

  ngOnInit() {
    this.model = new TermsConditionModel();
    this.pageName = "Terms_And_Condition";
    this.urlDefaultPage = this.authService.GetURL(
      ApplicationRouteURL.URL_DEFAULT_PAGE
    );

    this.typeList = WeGoConfig.TERMS_CONDITION_PRIVACYTYPE;

    if (!(this.authService.GetHighestRoleLevel() <= this.roleLevel.Instance)) {
      this.typeList = this.typeList.filter((x: any) => x != "Privacy");
    }
    this.urlTermsAndConditionList = this.authService.GetURL(
      ApplicationRouteURL.URL_TERMS_CONDITION_PAGE
    );
    this.GerTermsAndConditionDetail();

    this.module = this.translate.instant("LblTermsConditionPrivacy");
    this.breadCrumbTitle = this.isEditMode
      ? this.translate.instant("LblEditPage", [this.module])
      : this.translate.instant("LblAddPage", [this.module]);
    this.breadCrumbList = this.translate.instant("LblListPage", [this.module]);
  }

  ngAfterViewInit() {
    this.ctgSelect = new SlimSelect({
      select: "#ctg",
      showSearch: false,
      isMultiple: true
    });
  }

  public TypeChange() {
    if (this.model.type == "Privacy" && !this.isEditMode) {
      this.model.acceptanceMomentModel.contractTypeGroupList = [];

      this.model.acceptanceMomentModel.repeatTimeOpenApp = false;
      this.model.acceptanceMomentModel.repeatTimeInDay = 0;
      this.model.acceptanceMomentModel.everyTimeOpenApp = false;
      this.model.acceptanceMomentModel.makeBooking = false;
      this.model.acceptanceMomentModel.startBooking = false;
      this.model.acceptanceMomentModel.openBooking = false;
      this.model.acceptanceMomentModel.ctgSelection = false;
      this.model.acceptanceMomentModel.contractTypeGroupList = [];

      this.model.companyHashId = "";
      this.model.organizationHashId = "";
      this.model.sharedVehicleGroupHashId = "";
      this.model.subscriptionHashId = "";
    }
  }

  public resetAcceptanceMoment() { }

  public GetInstanceList(termsAndConditionsHashId: string) {
    let permissionType = "";
    if (this.isEditMode) {
      permissionType = PermissionType.EDIT;
    } else {
      permissionType = PermissionType.INSERT;
    }

    this.termsAndConditionsService
      .GetInstanceListDropdownList(
        termsAndConditionsHashId,
        this.pageName,
        permissionType
      )
      .subscribe(
        res => {
          this.apiResponse = res;
          this.instanceList = res.data;
          //this.model.instanceId = this.instanceList[0].instanceId;

          if (this.instanceList && this.instanceList.length > 0) {
            if (
              !this.isEditMode &&
              !this.model.instanceHashId &&
              this.instanceList.length == 1
            ) {
              this.model.instanceHashIdList = [];
              this.model.instanceHashIdList.push(this.instanceList[0].keyHash);
              this.model.instanceHashId = this.instanceList[0].keyHash;
            }
            this.OnInstanceChange();
          }
        },
        error => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public OnInstanceChange(): any {
    if (!this.isEditMode) {
      this.model.companyHashId = "";
      this.CompanyList = [];
      this.model.organizationHashId = "";
      this.OrganizationList = [];
      this.model.sharedVehicleGroupHashId = "";
      this.SVGList = [];
    }
    this.GetCompanyListDropdown();
  }

  public GetCompanyListDropdown() {
    if (!(this.authService.GetHighestRoleLevel() <= this.roleLevel.Instance)) {
      this.model.instanceHashIdList = this.instanceList.map((x: any) => x.keyHash);
    }
    if (this.model.instanceHashId) {
      this.companyService
        .GetCompanyListDropdownForAddUpdatePage(
          this.pageName,
          this.permissionType,
          this.model.instanceHashId
        )
        .subscribe(
          (res: any) => {
            this.CompanyList = res.data;

            if (this.CompanyList != null && this.CompanyList.length > 0) {
              if (!this.isEditMode && !this.model.companyHashId && this.CompanyList.length == 1) {
                this.model.companyHashIdList = [];
                this.model.companyHashIdList.push(this.CompanyList[0].keyHash);
                this.model.companyHashId = this.CompanyList[0].keyHash;
              }
              this.OnCompanyChange();
            }
          },
          (error: any) => {
            this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          }
        );
    } else {
    }
  }

  public OnCompanyChange(): any {
    if (!this.isEditMode) {
      this.model.organizationHashId = "";
      this.OrganizationList = [];
      this.model.sharedVehicleGroupHashId = "";
      this.SVGList = [];
    }
    this.GetOrganizationListDropdown();

    if (this.model.companyHashId && !this.model.organizationHashId) {
      this.model.acceptanceMomentModel.accountActivation = false;
    }
  }

  public GetOrganizationListDropdown() {
    if (!(this.authService.GetHighestRoleLevel() <= this.roleLevel.Company)) {
      this.model.companyHashIdList = this.CompanyList.map((x: any) => x.keyHash);
    }

    if ((this.model.instanceHashId && this.model.companyHashId)
      || (this.CompanyList.length > 1 && (!(this.authService.GetHighestRoleLevel() <= this.roleLevel.Company)))
    ) {
      this.organizationService
        .GetOrganizationListDropdownForAddUpdatePage(
          this.pageName,
          this.permissionType,
          null,
          this.model.companyHashId
        )
        .subscribe(
          (res: any) => {
            this.OrganizationList = res.data;

            if (
              this.OrganizationList != null &&
              this.OrganizationList.length > 0
            ) {
              if (
                !this.isEditMode && !this.model.organizationHashId &&
                this.OrganizationList.length == 1
              ) {
                this.model.organizationHashIdList = [];
                this.model.organizationHashIdList.push(
                  this.OrganizationList[0].keyHash
                );
                this.model.organizationHashId = this.OrganizationList[0].keyHash;
              }
              this.OnOrganizationChange();
            }
          },
          (error: any) => {
            this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          }
        );
    } else {
    }
  }

  public OnOrganizationChange(): any {
    if (!this.isEditMode) {
      this.model.sharedVehicleGroupHashId = "";
      this.SVGList = [];
    }
    this.GetSVGListDropdown();
  }

  public GetSVGListDropdown() {
    if (!(this.authService.GetHighestRoleLevel() <= this.roleLevel.Organization)) {
      this.model.organizationHashIdList = this.OrganizationList.map((x: any) => x.keyHash);
    }

    if (
      ((this.model.instanceHashId &&
      this.model.companyHashId ) || !(this.authService.GetHighestRoleLevel() <= this.roleLevel.Company) )&&
      this.model.organizationHashId
    ) {
      this.sharedVehicleGroupService
        .GetSharedVehicleDropdownListByOrganization(
          this.pageName,
          this.permissionType,
          this.model.organizationHashId
        )
        .subscribe(
          (res: any) => {
            this.SVGList = res.data;

            if (this.SVGList != null && this.SVGList.length > 0) {
              if (
                !this.isEditMode && !this.model.sharedVehicleGroupHashId &&
                this.SVGList.length == 1
              ) {
                this.model.sharedVehicleGroupHashIdList = [];
                this.model.sharedVehicleGroupHashIdList.push(
                  this.SVGList[0].keyHash
                );
                this.model.sharedVehicleGroupHashId = this.SVGList[0].keyHash;
              }
            }
          },
          (error: any) => {
            this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          }
        );
    } else {
    }
  }

  public OnSharedVehicleGroupChange(): any {
    if (!this.isEditMode) {
      this.model.subscriptionHashId = "";
    }
    this.SubscriptionList = [];
    this.GetContractTypeGroup();
    this.GetSubscriptionListDropdown();
    if (!this.model.sharedVehicleGroupHashId) {
      this.model.acceptanceMomentModel.ctgSelection = false;
      this.model.acceptanceMomentModel.contractTypeGroupList = [];
    }
  }

  public GetSubscriptionListDropdown() {
    if (
      this.model.instanceHashId &&
      this.model.companyHashId &&
      this.model.organizationHashId &&
      this.model.sharedVehicleGroupHashId
    ) {
      this.subscriptionService
        .GetSubscriptionDropdownList(
          this.permissionType,
          this.model.organizationHashId,
          this.model.sharedVehicleGroupHashId
        )
        .subscribe(
          (res: any) => {
            this.SubscriptionList = res.data;

            if (
              this.SubscriptionList != null &&
              this.SubscriptionList.length > 0
            ) {
              if (
                !this.isEditMode && !this.model.subscriptionHashId &&
                this.SubscriptionList.length == 1
              ) {
                this.model.subscriptionHashId = this.SubscriptionList[0].keyHash;
              }
            }
          },
          (error: any) => {
            this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          }
        );
    } else {
    }
  }

  public OnSubscriptionChange() {
    this.GetContractTypeGroup();
  }

  public GetContractTypeGroup() {
    if (this.model.sharedVehicleGroupHashId) {
      this.contractTypegroupService
        .GetDropdownListCTGBySVG(
          this.pageName,
          this.model.instanceHashId,
          this.model.companyHashId,
          this.model.sharedVehicleGroupHashId,
          this.model.subscriptionHashId
        )
        .subscribe(
          res => {
            this.contractTypeGroupList = res.data;

            setTimeout(() => {
              this.ctgSelect.set(
                this.model.acceptanceMomentModel.contractTypeGroupList
              );
            }, 200);
          },
          error => {
            this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          }
        );
    } else {
      this.contractTypeGroupList = [];
    }
  }

  private MceHtmlOutput($event: any) {
    //console.log($event);
    this.model.bodyHtml = $event;
  }

  public OnBackClick() {
    this.locationService.back();
  }

  OnSubmit(forms: any) {
    this.isLoading = true;
    if (this.ctgSelect.data) {
      this.model.acceptanceMomentModel.contractTypeGroupList = this.ctgSelect.data
        .getSelected()
        .map((x: any) => x.value);
    }

    this.termsAndConditionsService
      .UpdateTermsAndConditions(this.model)
      .subscribe(
        res => {
          if (res.data) {
            this.popupMsg = this.isEditMode
              ? this.translate.instant("LblRecordUpdatedSuccess", [this.module])
              : this.translate.instant("LblRecordAddedSuccess", [this.module]);
            this.ShowSuccessPopup();
          } else {
            this.errorModel = res.error;
            if (this.OldVersion) {
              this.model.version = this.OldVersion;
            }
          }
          this.isLoading = false;
        },
        error => {
          this.isLoading = false;
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public OnNewVersionClick() {
    this.OldVersion = this.model.version;
    this.newVersion = Number((this.model.version + 0.1).toFixed(2));
    this.newVersionModal.show();
  }

  public VersionChanged() {
    this.model.version = this.newVersion;
    this.newVersionModal.hide();
    this.OnSubmit(this.termsAndConditionForm.value);
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }
  public HideSuccessPopup(): void {
    this.successPopup.hide();
    this.OnBackClick();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
    this.OnBackClick();
  }

  public SuccessModalClick(): void {
    this.router.navigate([this.urlTermsAndConditionList]);
  }

  public GerTermsAndConditionDetail() {
    this.sub = this.activeRoute.params.subscribe(params => {
      this.isEditMode = false;
      this.termsAndConditionHashId = params["id"] || "";
      if (this.termsAndConditionHashId != "") {
        this.isEditMode = true;
        this.termsAndConditionsService
          .GetTermsAndConditionsByHashId(this.termsAndConditionHashId)
          .subscribe(
            res => {
              this.model = res.data;
              this.permissionType = PermissionType.EDIT;
              this.selectedContractTypeGroupList = this.model.acceptanceMomentModel.contractTypeGroupList;
              this.GetInstanceList(this.termsAndConditionHashId);
              this.GetContractTypeGroup();
            },
            error => {
              this.errorMessage = this.authService.HandleErrorStatusCode(error);
            }
          );
      } else {
        this.GetInstanceList(this.termsAndConditionHashId);
        this.permissionType = PermissionType.INSERT;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/termsandcondition/components/terms-condition-update.component.ts